import { getCsrfToken } from '@betterment/js-runtime';
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['internalAction'];

  private disabled = false;

  declare internalActionTargets: HTMLElement[];

  connect() {
    document.addEventListener('visibilitychange', () => {
      this.disabled = false;
    });
  }

  executePrimaryAction(e: KeyboardEvent) {
    if (this.isInternalAction(e.target as HTMLElement)) {
      return;
    }

    if ((this.isClick(e) || this.isEnterKeydown(e)) && !this.disabled) {
      this.disabled = true;
      this.submitLink();
    }
  }

  submitLink() {
    const isEcho = this.data.get('echo') === 'true';
    const isRemote = this.data.get('remote') === 'true';
    const url = new URL(this.path, window.location.origin);

    if (isEcho && isRemote) {
      throw new Error('Action card is configured with remote and echo. This is not allowed.');
    }

    const form = document.createElement('form');
    form.style.display = 'none';
    form.action = url.pathname;
    form.dataset.testid = 'action-card-form';

    if (isEcho) form.dataset.echo = 'true';
    if (isRemote) form.dataset.remote = 'true';

    if (this.method === 'get') {
      form.method = 'get';
    } else {
      form.method = 'post';
      url.searchParams.append('authenticity_token', getCsrfToken() ?? '');
      url.searchParams.append('_method', this.method);
    }

    Array.from(url.searchParams.entries()).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    this.element.appendChild(form);
    form.requestSubmit();
  }

  isInternalAction(target: HTMLElement) {
    return this.internalActionTargets.some(internalActionTarget => internalActionTarget.contains(target));
  }

  isClick(event: Event) {
    return event.type === 'click';
  }

  isEnterKeydown(event: KeyboardEvent) {
    return event.type === 'keydown' && (event.code === 'Enter' || event.keyCode === 13);
  }

  get path() {
    return this.data.get('path') || '';
  }

  get method() {
    return (this.data.get('method') || 'GET').toLowerCase();
  }
}
